import {apiClient} from 'core/apiClient';
import {ProductGroups} from 'core/constants/productGroups';

const BRANDS_URL = '/service/product-cards/brand-owners';
const PRODUCT_GROUPS_URL = '/service/product-groups';
const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function fetchBrands() {
    return (await apiClient.get(BRANDS_URL)).data;
}

export async function fetchFuzzyBrands(brandName: string) {
    try {
        return (
            await apiClient.post(`${BRANDS_URL}/fuzzy-search`, {
                brandName,
            })
        ).data?.suggestions?.map((d: any) => ({...d, value: d.brandNameNormalized}));
    } catch (e) {
        console.error(e);
        return [];
    }
}

export async function fetchProductGroups() {
    return (
        await apiClient.get(PRODUCT_GROUPS_URL, {
            baseURL: '/api/v1',
        })
    ).data;
}

export async function fetchProductCardTemplate(productGroupCode: keyof typeof ProductGroups) {
    return (
        await apiClient.get<ArrayBuffer>(`/service/product-cards/template`, {
            responseType: 'arraybuffer',
            params: {productGroupCode},
        })
    ).data as ArrayBuffer;
}

export type LoadProductCardFileStatus = 'PENDING' | 'PROCESSING' | 'SUCCESS' | 'FAILED';
export type LoadProductCardFileResponse = {
    status: LoadProductCardFileStatus;
    taskId: string;
};

export async function loadProductCardFile(file: File) {
    const formData = new FormData();
    const fileWithMimeType = new File([file], file.name, {type: XLSX_MIME_TYPE});

    formData.append('file', fileWithMimeType, fileWithMimeType.name);

    return (
        await apiClient.post<LoadProductCardFileResponse>(
            `/service/product-cards/load-file`,
            formData,
            {
                headers: {'Content-Type': 'multipart/form-data'},
            },
        )
    ).data;
}

export type ProductCardFile = {
    taskId: string;
    status: LoadProductCardFileStatus;
    productGroupCode: string;
    filename: string;
    totalRows: number;
    createdCount: number;
    errors: [
        {
            row: number;
            column: string;
            fieldName: string;
            message: string;
        },
    ];
    error: string;
    createdAt: string;
};

export async function getProductCardLoadStatus(taskId: string) {
    return (await apiClient.get<ProductCardFile>(`/service/product-cards/load-file/${taskId}`))
        .data;
}
